import { useQuery } from '@tanstack/react-query';
import { default as addressService } from "../services/address";

export const useTipovias = () => {

  return useQuery({
    queryKey: ['tipovias'],
    queryFn: () => addressService.fetchTipovias(),
    staleTime: 1000 * 60 * 30
  })
  
}